module.exports = __webpack_public_path__ + "img/2_1-finanziario-ristorante-0.43ec27cb.png";